import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import "./styles/reset.css"
import "./styles/global.css"

Vue.config.productionTip = false

router.afterEach(() => {
  window.requestAnimationFrame(() => {
    const content = document.querySelector(".layout-content")
    if (content) content.scrollTop = 0
  })
})

new Vue({
  router,
  render: h => h(App)
}).$mount("#app")
